import(/* webpackMode: "eager" */ "/home/runner/work/chain-zen/chain-zen/apps/web-app/src/app/page.tsx");
